import { HelpContent } from '../../../UI-Lib/Help-Tooltip';

export const LINKED_PARCELS_HELP: HelpContent[] = [
    {
        helpContentId: 'linked-parcels.master-parcel',
        tooltipText: 'Master parcel'
    }
];
